import React, { useState } from 'react';
import { Modal, Button, Form } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave } from '@fortawesome/free-solid-svg-icons';
import { uploadFile } from '../../services/tablesService';

const FileModal = ({ show, handleClose, data }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadError, setUploadError] = useState(null);
    console.log(selectedFile)
    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const handleSave = async () => {
        if (!selectedFile) {
            setUploadError('Выберите файл для загрузки');
            return;
        }

        try {
            const uploadedFile = await uploadFile(selectedFile);
            console.log('Загруженный файл:', uploadedFile);
            setUploadError(null);
            handleClose();
        } catch (error) {
            setUploadError('Ошибка загрузки файла');
            console.error('Ошибка загрузки файла:', error);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FontAwesomeIcon icon={faEdit} className="me-2" /> Редактировать файл
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {data ? (
                    <div>
                        <h5>Файл: {data.name || 'Без названия'}</h5>
                        <a href={data.url} target="_blank" rel="noopener noreferrer">
                            Просмотр текущего файла
                        </a>
                        <Form.Group className="mt-3">
                            <Form.Label>Заменить файл:</Form.Label>
                            <Form.Control type="file" onChange={handleFileChange} />
                            {uploadError && <p className="text-danger">{uploadError}</p>}
                        </Form.Group>
                    </div>
                ) : (
                    <Form.Group>
                        <Form.Label>Добавить новый файл:</Form.Label>
                        <Form.Control type="file" onChange={handleFileChange} />
                        {uploadError && <p className="text-danger">{uploadError}</p>}
                    </Form.Group>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Закрыть
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    <FontAwesomeIcon icon={faSave} className="me-2" /> Сохранить изменения
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FileModal;
